import { render, staticRenderFns } from "./ProductsReportTableUser.vue?vue&type=template&id=8a4286a8&scoped=true"
import script from "./ProductsReportTableUser.vue?vue&type=script&lang=js"
export * from "./ProductsReportTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4286a8",
  null
  
)

export default component.exports